<h2 mat-dialog-title class="mat-dialog-title">{{'imageuploadDialog.registerImages' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="start center">
  <div class="form-container">
    <div class="d-flex">
      <div class="template-image" fxLayout="column" fxLayoutAlign="end start">
        <button class="uploadbutton" mat-button color="primary" (click)="uploadbuttoninput.click();">
          <mat-icon aria-label="">unarchive</mat-icon>{{'imageuploadDialog.selectImage' | translate}}
        </button>
        <span *ngIf="fileDisplayName">{{fileDisplayName}}</span>
        <input hidden #uploadbuttoninput type="file" accept="image/jpe,/image/jpg,image/jpeg,image/gif,image/x-png,image/bmp" (change)="selectImage($event.target.files); uploadbuttoninput.value=''" />
      </div>
    </div>
    <div class="btn-container">
      <mat-dialog-actions>
        <button mat-button color="primary" mat-dialog-close>{{'imageuploadDialog.cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="uploadImage()" [disabled]="!fileDisplayName">
          {{'imageuploadDialog.upload' | translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
<div *ngIf="templateImages && templateImages.length > 0">
      <div class="template-image-container" fxLayout="row" fxLayoutAlign="start start">
        <div class="template-image-content" fxlayout="row">
          <h4>{{'imageuploadDialog.images' | translate}}</h4>
          <div fxLayout="row wrap" fxLayoutAlign="start start">
            <div *ngFor="let templateImage of templateImages" class="template-image-card-wrap">
              <mat-card appearance="outlined" class="image-card">

                <img mat-card-image *ngIf="templateImage.imageUrl" [src]="templateImage.imageUrl" alt="">
                <button class="image-card-delete" mat-raised-button (click)="deleteImage(templateImage)">
                  <mat-icon aria-label="">clear</mat-icon>
                </button>
                <mat-card-content class="image-card-content">
                  <b>{{templateImage.name}}</b>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
